import { AppDispatch } from '../../types/store'
import { ruleCardActions } from '../slices/ruleCardSlice'

export const modifyRuleCardConfig =
    (payload: { path: string[]; data: any }) => (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.modifyRuleCardConfig(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const initRuleEmptyData =
    (payload: { path: string[]; name: string; schema: Record<string, any> }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.initRuleEmptyData(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const enableRuleBlock =
    (payload: { path: string[]; data: Record<string, any> }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.enableRuleBlock(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const disableRuleBlock =
    (payload: { path: string[]; errorKeyName: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.disableRuleBlock(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const deleteRuleBlockDictItem =
    (payload: { path: string[]; data: any; dictionaryKey: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.deleteRuleBlockDictItem(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const deleteRuleBlockArrayItem =
    (payload: { path: string[]; index: number }) => (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.deleteRuleBlockArrayItem(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const modifyRuleArrayScalarValues =
    (payload: {
        path: string[]
        componentState: any
        name: string
        isEmptyAsNull?: boolean
    }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.modifyRuleArrayScalarValues(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const addItemToArrayEnd =
    (payload: { path: string[]; data: any }) => (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.addItemToArrayEnd(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const addItemToArrayBeginning =
    (payload: { path: string[]; data: any }) => (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.addItemToArrayBeginning(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const deleteRuleBlockArrayCardItem =
    (payload: { path: string[]; data: any[]; errorKeyName: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.deleteRuleBlockArrayCardItem(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const duplicateRuleArrayCardItem =
    (payload: { path: string[]; data: { index: number; item: any } }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.duplicateRuleBlockArrayCard(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const modifyRuleInput =
    (payload: {
        componentState: any,
        path: string[],
        data: any,
        name: string,
    }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.modifyRuleInput(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const setRuleCardRuleName =
    (payload: { path: string[]; ruleName: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.setRuleCardRuleName(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const changeRuleCardState =
    (payload: boolean) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.changeRuleCardState(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const addRuleBlockDictNewKey =
    (payload: { path: string[]; oldKey: string; data: any }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.addRuleBlockDictNewKey(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }

export const addRuleBlockDictItem =
    (payload: { path: string[]; item: any; data: any }) =>
    (dispatch: AppDispatch) => {
        dispatch(ruleCardActions.addRuleBlockDictItem(payload))
        dispatch(ruleCardActions.checkRuleUnsavedChanges())
    }


